import {Box, Grid, Statistic} from '@primer/react-brand'
import {renderWithoutParagraphs} from '../../../../utils'
import type {IntroSectionProps} from '../types'

type Props = Pick<IntroSectionProps, 'introStats'>

export function IntroStats({introStats}: Props) {
  if (!introStats || introStats.length === 0) return null

  return (
    <Box marginBlockStart={{narrow: 48, regular: 80}} marginBlockEnd={{narrow: 48, regular: 80}}>
      <Grid>
        {introStats.map(stat => (
          <Grid.Column key={stat.sys.id} span={{medium: 4}}>
            <Statistic>
              <Statistic.Heading>{renderWithoutParagraphs(stat.fields.heading)}</Statistic.Heading>
              <Statistic.Description>{renderWithoutParagraphs(stat.fields.description)}</Statistic.Description>
            </Statistic>
          </Grid.Column>
        ))}
      </Grid>
    </Box>
  )
}
